import { css } from "styled-components";
import { grey10, grey5, spacing8, spacing16, sans, fontSize14, lineHeight, fontWeightNormal, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import { StyledTHead } from "./THead";
import { StyledTR } from "./TR";
const border = `1px solid ${grey10}`;
const headerBottomBorderWidth = "3px";
export const cell = css(["padding:0;", ";", ";", " &{border-block-end:", ";font-weight:", ";line-height:", ";vertical-align:bottom;&[colspan]{background-color:", ";font-weight:", ";text-align:center;}}&:first-child{border-inline-start:0;}", " ", ":last-of-type &{border-block-end:0;}"], ({
  verticalRuled
}) => `border-inline-start: ${verticalRuled ? border : "0"}`, ({
  horizontalRuled
}) => `border-block-end: ${horizontalRuled ? border : "0"}`,
/* sc-selector */
StyledTHead, border, fontWeightBold, lineHeight, grey5, fontWeightNormal,
/* sc-selector */
StyledTHead, StyledTR);
/*
NOTE: Normally, we would just a apply a 3px grey bottom border to the cells in
the last row of the thead. However, when using sticky headers, the bottom
borders do not stick. Instead, we use an inset 3px box-shadow for the bottom
line.
*/

export const cellContents = css(["padding:", ";", ";vertical-align:top;font-family:", ";font-size:", ";", " ", ":last-of-type &&{box-shadow:inset 0px -", " 0px 0px ", ";padding-block-end:calc(", " + ", ");}& input{", ";}"], paddingHelper, ({
  dataType = "normal"
}) => `text-align: ${dataType === "normal" ? "start" : "end"}`, sans, fontSize14,
/* sc-selector */
StyledTHead, StyledTR, headerBottomBorderWidth, grey10, headerBottomBorderWidth, paddingHelper, ({
  dataType = "normal"
}) => `text-align: ${dataType === "normal" ? "start" : "end"}`); // Helper for determining the padding value based on the theme `spacing`

function paddingHelper({
  spacing
}) {
  return spacing === "condensed" ? spacing8 : spacing16;
}